import React, { useContext, useState } from 'react'
import { Context } from '../../Context/Context'
import { DEFAULTAVATAR } from '../../Constants';
import { signOut } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import MiniAvatarModal from 'Modals/MiniAvatarModal';

function HomeMiniAvatar() {
    const {userDetails, setUserDetails} = useContext(Context);
    const {profilePic} = userDetails;
    const navigate = useNavigate();

    const [showOptions, setShowOptions] = useState(false);
    const signOutFunc = async() => {
      try {
        const signout = await signOut();
          localStorage.clear();
          navigate("/");
      }
      catch(error)
      {
        console.log(error);
      }
        
    }
  return (
    <>
        <div className={'flex lg:mx-4 lg:w-10 lg:h-10 w-6 h-6 border ring-2 rounded-full ring-gray-400' + (userDetails.verified ? ' ring-green-600' : '')}
        onClick={()=>setShowOptions((prev) => !prev)}
        >
            <img src={profilePic && profilePic !== "" ? profilePic : DEFAULTAVATAR} alt="Preview" />
        </div>
        {showOptions &&
          <MiniAvatarModal onClose={()=>setShowOptions(false)} uploadNew={showOptions} />
        }
    </>
  )
}

export default HomeMiniAvatar
